$(function () {
  let activeType = $(".help-content-wrap ul li").eq(0).attr("data-type");
  $(`.help-content-wrap ul li[data-type="${activeType}"]`).addClass("active");
  $(
    `.list-item-content .list-item-content-item[data-type="${activeType}"]`
  ).removeClass("hide");
  // type类型切换
  $(`.help-content-wrap ul li`).on("click", function () {
    $(`.help-content-wrap ul li`).removeClass("active");
    $(".list-item-content .list-item-content-item").addClass("hide");
    var num = $(".help-content-wrap ul li").index(this);
    activeType = $(".help-content-wrap ul li").eq(num).attr("data-type");
    $(`.help-content-wrap ul li[data-type="${activeType}"]`).addClass("active");
    $(
      `.list-item-content .list-item-content-item[data-type="${activeType}"]`
    ).removeClass("hide");
  });
});
